<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4 7.5H20V10.5C18.8954 10.5 18 11.3954 18 12.5C18 13.6046 18.8954 14.5 20 14.5V17.5H4V14.5C5.10457 14.5 6 13.6046 6 12.5C6 11.3954 5.10457 10.5 4 10.5V7.5Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path d="M9.5 7.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  <path d="M14.5 7.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
</svg>
